import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "@tanstack/react-router";
import { PageTitle } from "@/contexts/page-title-context";
import { ScrollingWizardContainer } from "@/components/load-creation/scrolling-wizard-container";
import { LoadFormProvider, useLoadForm } from "@/lib/contexts/LoadFormContext";
import { Step1RouteSelection } from "@/components/load-creation/steps/step-1-route-selection";
import { Step2LoadDetails } from "@/components/load-creation/steps/step-2-load-details";
import { Step3AgreementTerms } from "@/components/load-creation/steps/step-3-agreement-terms";
import { Step3Payment } from "@/components/load-creation/steps/step-3-payment";
import { Step4Review } from "@/components/load-creation/steps/step-4-review";
import { Step5Documents } from "@/components/load-creation/steps/step-5-documents";

function LoadCreationScrollContent() {
  const navigate = useNavigate();
  const { t: tLoads } = useTranslation("loads");
  const { handleSubmit } = useLoadForm();

  const handleCancel = () => {
    void navigate({ to: "/loads" });
  };

  const handleCreateLoad = async () => {
    const load = await handleSubmit();
    if (load) {
      void navigate({ to: "/loads" });
    }
  };

  const sections = useMemo(
    () => [
      {
        id: "route",
        title: tLoads("route"),
        component: <Step1RouteSelection />,
      },
      {
        id: "cargo",
        title: tLoads("cargo"),
        component: <Step2LoadDetails />,
      },
      {
        id: "payment",
        title: tLoads("financials"),
        component: <Step3Payment />,
      },
      {
        id: "terms",
        title: tLoads("agreementTermsTitle"),
        component: <Step3AgreementTerms />,
      },
      {
        id: "documents",
        title: tLoads("documents"),
        component: <Step5Documents />,
      },
      {
        id: "review",
        title: tLoads("review"),
        component: <Step4Review />,
      },
    ],
    [tLoads],
  );

  return (
    <>
      {/* load-creation-scroll-page */}
      <PageTitle>{tLoads("newLoad")}</PageTitle>

      <ScrollingWizardContainer
        sections={sections}
        onSubmit={handleCreateLoad}
        onCancel={handleCancel}
        submitLabel={tLoads("createLoad")}
      />
    </>
  );
}

function NewLoadScrollPage() {
  return (
    <LoadFormProvider>
      <LoadCreationScrollContent />
    </LoadFormProvider>
  );
}

export const Route = createFileRoute("/_app/loads/new")({
  component: NewLoadScrollPage,
});
